import { FootballQualifiers } from '../enums';
import { isLacrosse } from '../utils/exchange';

export const odkQualifiers = [FootballQualifiers.O, FootballQualifiers.D, FootballQualifiers.K];

export const tvQualifiers = [
  FootballQualifiers.TV_Full, FootballQualifiers.TV_1, FootballQualifiers.TV_2,
  FootballQualifiers.TV_3, FootballQualifiers.TV_4, FootballQualifiers.TV_5,
];

export const additionalAttachments = (sport: string) => {
  if (isLacrosse(sport)) return ['csv', 'xml', 'json'];
  return [];
};

// Max file size is 25MB
export const isAttachmentFileSizeValid = (file: File) => {
  const fileSize = file.size / (1024 * 1024);
  if (fileSize > 25) return false;
  return true;
};
